import UserApi from '../api'

export const getCurrentUser = async ({ commit, rootState }) => {
  // rootState.catalog.defaultDocument = 'schet'
  let response = await UserApi.getCurrentUser()
  if (response.success) {
    commit('SET_USER', response.current_user)
    commit('shipment/SET_STORES', response.stores, { root: true })
    commit('minsk/SET_STORES', response.stores, { root: true })
    commit('regions/SET_STORES', response.stores, { root: true })
  } else {
    commit('SET_ERROR', response.error)
  }
}

export const saveCurrentUser = async ({ commit }, payload) => {
  let response = await UserApi.saveCurrentUser(payload)
  if (response.success) {
    commit('SET_USER', response.current_user)
  } else {
    commit('SET_ERROR', response.error)
  }
}

export const changePassword = async ({ commit }, payload) => {
  let response = await UserApi.changePassword(payload)
  if (!response.success) {
    commit('SET_ERROR', response.error)
  }
}

export const setError = ({ commit }, payload) => {
  commit('SET_ERROR', payload)
}
